import React, { useContext, useEffect } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import MainContext from '../store/MainContext';
import Login from './Public/Login';
import Verify from './Public/Verify';
import Forget from './Public/Forget';
import ProtectedRoutes from './Protected/';
import axios from '../api/axios';
import Logout from './Public/Logout';
import { useQuery } from 'react-query';

const Routes = () => {
  const { state, dispatch } = useContext(MainContext);
  const isAuth = state.Auth.logged ? true : false;

  const loadPublicSettings = async () => {
    const { data } = await axios.get('/api/v1/admin/setting/public');
    data && dispatch({ type: 'PUBLIC', payload: data, action: 'SET' });
    return data;
  };

  const { data } = useQuery('loadPublic', loadPublicSettings, {
    cacheTime: 24 * 60 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/login"
          render={() => (isAuth ? <Redirect to="/protected" /> : <Login />)}
        />
        <Route
          path="/verify"
          render={() => (isAuth ? <Redirect to="/protected" /> : <Verify />)}
        />
        <Route path="/logout" render={() => <Logout />} />
        <Route
          path="/forget"
          render={() => (isAuth ? <Redirect to="/protected" /> : <Forget />)}
        />
        <Route path="/protected">
          <ProtectedRoutes />
        </Route>
        <Route path="/" render={() => <Redirect to="/login" />} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
